import { isEmptyEquivalentValue } from '@app/src/utils/emptyEquivalentValues'
import React from 'react'
import { useIntl } from 'react-intl'
import CategoryCell from './CategoryCell'
import EmptyCell from './EmptyCell'

type Props = {
  value?: string
  valuesIntlPrefix: string
  disableCell?: boolean
}

// An enum column in the MRT tables: the value is translated through `<valuesIntlPrefix>.<value>` and
// shown as a chip, except when it is missing or is one of the members that mean an absence - those
// share the same Empty placeholder as a cell that holds nothing.
const EnumCategoryCell: React.FC<Props> = ({ value, valuesIntlPrefix, disableCell }) => {
  const { formatMessage } = useIntl()

  if (!value || isEmptyEquivalentValue(value)) return <EmptyCell disableCell={disableCell} />

  return <CategoryCell value={formatMessage({ id: `${valuesIntlPrefix}.${value}` })} disableCell={disableCell} />
}

export default EnumCategoryCell
